import loadable from '@loadable/component';

const SettingsDetailPage = loadable(() => import('./page'));


export const routes = [
  {
    path: '',
    element: <SettingsDetailPage />,
  },
];